import React from 'react'
import { useWalletContext } from '../WalletContext'
import PrimaryButton from '../PrimaryButton'
import { WALLET_SUFFICIENT_BALANCE, isSufficientBalanceInWallet } from '../../model/tokens/helper'

function SwapButton(props: { network: any; handleSwap: any; activePoolId: any; token1: any; token1Amount: any; token2: any; token2Amount: any; swapInProgress: boolean }) {
    const { network, handleSwap, activePoolId, token1, token1Amount, token2, token2Amount, swapInProgress } = props
    const { walletAddress: connectedAddress, connect } = useWalletContext()

    const swapButton = () => {
        const token1SufficientBalance = isSufficientBalanceInWallet(network, token1, token1Amount)
        let token2InsufficientPoolBalance = false
        // try {
        //     const isInsuf = isInsufficientBalanceInPool(network, activePoolId, token2, token2Amount)
        //     token2InsufficientPoolBalance = isInsuf
        // } catch (e) {
        //     token2InsufficientPoolBalance = false
        // }

        if (token2 && token1Amount > 0 && token1SufficientBalance === WALLET_SUFFICIENT_BALANCE.TRUE && !token2InsufficientPoolBalance && token1Amount && token2Amount) {
            // Display SWAP button
            return (
                <PrimaryButton className='mt-4' isDisabled={false} isLoading={swapInProgress} onClick={handleSwap}>
                    {swapInProgress ? <span>Swapping</span> : <span>Swap</span>}
                </PrimaryButton>
            )
        }

        if (connectedAddress && token1Amount > 0 && token1SufficientBalance !== WALLET_SUFFICIENT_BALANCE.TRUE && !token2InsufficientPoolBalance) {
            // Amount either exceeds wallet balance, or wallet balance is unknown yet
            return (
                <PrimaryButton className='mt-4' isDisabled={true} isLoading={token1SufficientBalance === WALLET_SUFFICIENT_BALANCE.UNKNOWN}>
                    {token1SufficientBalance === WALLET_SUFFICIENT_BALANCE.FALSE ? <span>Amount Exceeds Wallet Balance</span> : <span>Checking Wallet Balance</span>}
                </PrimaryButton>
            )
        }

        if (token1 && token2 && activePoolId === 0) {
            // No pool for token pair selected
            return (
                <PrimaryButton className='mt-4' isDisabled={true}>
                    <span>Not A Valid Pool</span>
                </PrimaryButton>
            )
        }

        if (token1 && token2 && activePoolId && token2Amount && token2InsufficientPoolBalance) {
            return (
                <PrimaryButton isDisabled={true}>
                    <span>Insufficient Liquidity In Pool</span>
                </PrimaryButton>
            )
        }

        if (connectedAddress) {
            // Wallet is connected
            let instruction = ''
            if (!token1 && !token2) instruction = 'Select Tokens'
            if ((!token1 && token2) || (token1 && !token2)) instruction = 'Select Token'
            if (token1 && token2 && (!token1Amount || !token2Amount)) instruction = 'Enter Amount'

            if (instruction !== '')
                return (
                    <PrimaryButton className='mt-6' isDisabled={true}>
                        <span>{instruction}</span>
                    </PrimaryButton>
                )
        }

        if (!connectedAddress) {
            return (
                <PrimaryButton className='mt-6' onClick={() => connect()}>
                    <span>Connect Wallet</span>
                </PrimaryButton>
            )
        }
        return <div></div>
    }

    return swapButton()
}

export default SwapButton
